<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="template != null"
    fluid
    style="padding-left: 25px; padding-right: 25px;"
>
    <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      v-if="template.send_mode == 'manual'"
    >
      {{template.template_label}} is currently in manual mode &mdash; as a result generated messages will <b>not</b> be automatically sent.

      <div
        style="text-align: right"
      >
        <v-btn
            style="margin-right: 15px"
            v-on:click="onClickModeDisable"
        >
            Disable...
        </v-btn>
        <v-btn
            style="margin-right: 15px"
            v-on:click="onClickEdit"
        >
            Edit...
        </v-btn>
        <v-btn
            color="primary"
            v-on:click="onClickModeAuto"
        >
            Change Send Mode...
        </v-btn>

        <m-auto-message-set-send-mode-dialog
            ref="set-send-mode-dialog"
            v-on:change="doChangeSendMode"
        />
      </div>
   </v-alert>


    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="search_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="update()"
                >
                    <v-list-item-title>Refresh</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="excelExport()"
                >
                    <v-list-item-title>Export (last 30 days)...</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu> 
    </v-text-field>

    <v-checkbox
        label="Limit Search to Messages 30 days old or less"
        style="margin-top: -15px"
        v-model="limit_to_30_days"
        v-on:change="doUpdate"
    />

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"
    >

        <template v-slot:item.date="{ item }">
            {{prettyPrintDate(item.at_time)}}
        </template>

        <template v-slot:item.time="{ item }">
            {{prettyPrintTime(item.at_time)}}
        </template>

        <template v-slot:item.first_name="{ item }">
            {{prettyFirstName(item)}}
        </template>

        <template v-slot:item.last_name="{ item }">
            {{prettyLastName(item)}}
        </template>

        <template v-slot:item.send_to="{ item }">
            {{$rc.pretty(item.send_to)}}
        </template>

        <template v-slot:item.message="{ item }">
            {{prettyPreparedMessage(item)}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
                v-if="item.state != 'cancelled'"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    <v-list-item
                        v-if="item.state == 'ready-to-schedule' || item.state == 'scheduled'"
                        v-on:click="onClickCancel(item)"
                    >
                        <v-list-item-title>Cancel</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="item.message_params['url_view_in_crm'] != null"
                        v-on:click="onClickViewOrderInCommerce7(item)"
                    >
                        <v-list-item-title>View order in Commerce7...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="item.sent_stored_message_conversation_id != null"
                        v-on:click="onClickViewConversation(item)"
                    >
                        <v-list-item-title>View conversation...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="item.state == 'ready-to-schedule'"
                        v-on:click="onClickSend(item)"
                    >
                        <v-list-item-title>Send...</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="onClickTechnicalDetail(item)"
                    >
                        <v-list-item-title>View technical details...</v-list-item-title>
                    </v-list-item>
                    
                </v-list>
            </v-menu>
        </template>

     </v-data-table> 

    
    
     <div 
        style="text-align: right; margin-top: 15px;"
    >
    
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onClickAddMessage"
            v-if="template.send_mode != 'disabled'"
        >
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>

        <div
            v-else
        >
            The message template is disabled.  You can not trigger a new message<br/><br/>
            <v-btn
                v-on:click="onClickTemplateSettings"
            >
                Template Settings...
            </v-btn>
        </div>
    </div>
    
   
</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');

export default {
    data() {
        return {
            organization_label: null,
            template: null,
            search_text: null,
            results: null,
            limit_to_30_days: true,
            param_variables: [],
        }
    },

    mounted () {
        this.getTemplate();
        this.doUpdate();
    },

    methods: {

        update: _.debounce(function()
        {
            this.doUpdate();
        },1001),

        doUpdate()
        {
            let at_time_filter = null;

            if ( this.limit_to_30_days )
            {
                let today = new Date();
                let thirty_days_ago = new Date(new Date().setDate(today.getDate() - 30));
                at_time_filter = { 'type': 'greater-than', 'value': thirty_days_ago.getUTCMilliseconds() };
            }

            let search = {
                'organization_id' : this.$route.params.organization_id,
                'template_subject_id' : this.$route.params.template_subject_id,
                'template_context' : this.$route.params.template_context,
                'full_text' : this.search_text,
                'at_time': at_time_filter,
                'sort' : 'at_time:desc'
            };

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/auto-messages',
            
                search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                    this.param_variables = data.param_variables;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search auto messages');
                },
            );
        },

        getTemplate() {

            let params = {
                'organization_id' : this.$route.params.organization_id,
                'template_subject_id' : this.$route.params.template_subject_id,
                'template_context' : this.$route.params.template_context,
            };
            
            this.$rc.getAutoMessageTemplateProfile(
                params,
            
                (data) => {

                    this.organization_label = data.organization_label;
                    this.template = data.template;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get template information');
                },
            );
        },

        prettyPrintDate(time)
        {
            return Time.getISODate(time);
        },

        prettyPrintTime(time)
        {
            return Time.getPeriodClockTime(time);
        },

        prettyFirstName(item)
        {
            let params = item.message_params;
            return params['first-name'] ?? params.first_name ?? 'Unknown';
        },

        prettyLastName(item)
        {
            let params = item.message_params;
            return params['last-name'] ?? params.last_name ?? 'Unknown';
        },

        prettyPreparedMessage(item)
        {
            if ( item.prepared_message  == null )
                return '';

            return item.prepared_message.text ?? '';
        },

        onClickAddMessage()
        {
            this.$router.push({
                'name': 'auto-messages-manual-trigger',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'template_context' : this.$route.params.template_context,
                    'template_subject_id': this.$route.params.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        onClickTemplateSettings()
        {
            this.$router.push({
                'name': 'auto-messages-template-settings',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'template_context' : this.$route.params.template_context,
                    'template_subject_id': this.$route.params.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        onClickSend(message)
        {
            this.$rc.showSpinner();
            
            this.$rc.sendAutoMessage(
                message.auto_message_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Message scheduled to be sent');
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to schedule message');
                },
            );
        },

        onClickViewOrderInCommerce7(message)
        {
            let url = message.message_params['url_view_in_crm'];

            window.open(url,"_blank");
        },

        onClickViewConversation(message)
        {
            this.$rc.toHomeForEndpoint(this.$router, message.scheduled_async_sent_from, false, message.sent_stored_message_conversation_id);
        },

        onClickCancel(message)
        {
            this.$rc.showSpinner();
            
            this.$rc.cancelAutoMessage(
                message.auto_message_id,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to cancel message');
                },
            );
        },

        onClickTechnicalDetail(item)
        {
            this.$rc.copy_code_dialog({
                'title': 'Automed Message Technical Details',
                'object': item,
            });
        },

        excelExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/auto-messages',
                    {
                        'organization_id': this.$route.params.organization_id,
                        'template_context': this.$route.params.template_context,
                    }
                );
        },

        onClickModeAuto()
        {
            /*this.$rc.confirm({
                'title': 'Confirm Auto Mode',
                'body': 'You are about to put this autoamted message into automatic mode &mdash; this means that generated messages will be immediately sent to their intended recipients.<br/><br/>Would you like to proceed and place this message into automatic mode?',
                'btn_text_ok': 'Send Message Automatically',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.template.send_mode = 'auto';
                    this.doSave();
                },
            });*/

            this.$refs['set-send-mode-dialog'].showDialog(this.template.send_mode);
        },

        doChangeSendMode(new_value) 
        {
            this.template.send_mode = new_value;
            this.doSave();
        },

        onClickModeDisable()
        {
            this.$rc.confirm({
                'title': 'Confirm Disable Automated Message',
                'body': 'You are about to disable this automated message &mdash; when disabled no messages will be generated for review or sent and you will not receive any more reminders to review this message<br/><br/>Would you like to proceed and disable this message?',
                'btn_text_ok': 'Disable this message',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.template.send_mode = 'disabled';
                    this.doSave();
                },
            });
        },

        doSave()
        {
            this.$rc.putAutoMessageTemplate(
                this.template,
            
                (data) => {
                    this.template = data.template;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save automated message settings.');
                },
            );
        },

        onClickEdit()
        {
            this.$router.push({
                'name': 'auto-messages-template-settings',
                'params' : {
                    'organization_id' : this.template.organization_id,
                    'template_context' : this.template.template_context,
                    'template_subject_id': this.template.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },
    },

    computed: {
        title() {
            let template = this.template;

            if ( template == null )
                return "Search Messages";

            return "Search Messages: "+template.template_label;
        },

        headers() {
            var ret = [
                { text: 'By System', value: 'by_system'},
                { text: 'Date', value: 'date' },
                { text: 'Time', value: 'time' },
                { text: 'Message Type', value: 'template_label'},
            ];

            this.param_variables.forEach(
                (item) => {
                    ret.push({'text': item.column_label, 'value': item.column_id});
                }
            );

            ret = ret.concat([
                { text: 'Send To', value: 'send_to' },
                { text: 'Message', value: 'message' },
                { text: 'Status', value: 'state_desc' },
                { text: 'Action', value: 'action' },
            ]);

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>